import { Link } from 'gatsby'
import React, { ReactNode } from 'react'
import { Arrow } from '../../../../icons'
import './multilevel-collapse.css'

interface MultiLevelCollapseProps {
  activeCountry: string
  onClick: () => void
  url: string
  title: string
  isExpanded: boolean
  children?: ReactNode | ReactNode[]
}

export const MultiLevelCollapse: React.FC<MultiLevelCollapseProps> = ({
  activeCountry,
  onClick,
  url,
  title,
  isExpanded,
  children,
  amplitude,
}) => {
  return (
    <>
      <li
        className={`multilevel-collapse-container multi-level-country-${
          activeCountry && activeCountry.toLowerCase()
        }`}
        onClick={onClick}
      >
        <Link
          to={url}
          className={
            isExpanded
              ? 'multilevel-collapse-title multilevel-collapse-open'
              : 'multilevel-collapse-title'
          }
          data-amplitude={amplitude}
        >
          {title === 'Pay Later Offers (US)' ? 'Pay Later Offers' : title}
        </Link>
        <div className="multilevel-arrow-icon-container" onClick={onClick}>
          <Arrow expanded={isExpanded} onClick={onClick} />
        </div>
      </li>
      {isExpanded && children}
    </>
  )
}
